import React from "react";

import { CloseRounded, SendRounded } from "@mui/icons-material";
import { Box, DialogContent } from "@mui/material";
import { httpsCallable } from "firebase/functions";

import useFirebase from "../../../../../config/context/firebaseContext";
import useModal from "../../../../../config/context/modalContext";
import { Dev } from "../../../../../config/util/consoleUtil";

import MainSolidButton from "../../../../../components/MainSolidButton";
import { ModalTransition } from "../../../../../components/ModalTransition";
import PageHeader from "../../../../../components/PageHeader";

import SimpleBase64 from "../../../../../components/InputImage/SimpleBase64";
import AutocompleteMain from "../../../../../components/InputMain/AutocompleteMain";
import SwitchMain from "../../../../../components/InputMain/SwitchMain";
import TextMain from "../../../../../components/InputMain/TextMain";
import { WideDialog } from "../../../../../components/MainModalSimple/styles";
import MainText from "../../../../../components/MainText";

import { ModalBaseType } from "../../../../../types/common";
import { UserUploadedFileType } from "../../../../../types/database";

export default function ModalFileCreate({ onClose }: ModalBaseType) {
  const [open, setOpen] = React.useState(true);

  const { pushAlert } = useModal();

  const { functions } = useFirebase();

  const [descriptionField, setDescriptionField] = React.useState("");
  const [bucketField, setBucketField] = React.useState("");
  const [isPublic, setIsPublic] = React.useState(true);

  const [loading, setLoading] = React.useState(false);

  const [uploadedFile, setUploadedFile] = React.useState<UserUploadedFileType[]>([]);

  const handleSend = async () => {
    try {
      setLoading(true);
      const saveFileToBucket = httpsCallable(functions, "saveFileToBucket");

      const response = await saveFileToBucket({
        bucket: bucketField,
        file: { ...uploadedFile[0], description: descriptionField, public: isPublic },
      });

      console.log(response);

      pushAlert({
        type: "success",
        message: "Arquivo enviado",
      });

      handleClose(true);
    } catch (error) {
      console.log(...new Dev("handleSend", error).Error());
      pushAlert({
        type: "error",
        message: "Erro ao enviar arquivo",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = (reload?: boolean) => {
    setOpen(false);
    setTimeout(() => {
      if (onClose) onClose(reload);
    }, 200);
  };

  return (
    <WideDialog
      fullWidth={true}
      open={open}
      onClose={() => handleClose()}
      TransitionComponent={ModalTransition}
    >
      <DialogContent>
        <PageHeader
          size="subtitle"
          title={"Enviar Arquivo"}
          rightIcon={<CloseRounded />}
          onRightAction={() => handleClose()}
        />

        <Box>
          <AutocompleteMain
            name="Bucket"
            value={bucketField}
            options={["spott", "rating", "admin", "cafeteria", "temporary"]}
            onChange={setBucketField}
          />

          <TextMain
            name="Descrição"
            textColor="regular"
            value={descriptionField}
            onChange={setDescriptionField}
          />

          <MainText size="small" color="regular">
            Todos os arquivos são publicos, isso é só um indicador.
          </MainText>
          <SwitchMain name="Arquivo Público" checked={isPublic} onChange={setIsPublic} />

          <Box>
            <SimpleBase64 fileList={uploadedFile} setFileList={setUploadedFile} maxInput={1} />
          </Box>

          <Box my={3}>
            <MainSolidButton
              loading={loading}
              text="Enviar"
              icon={<SendRounded />}
              onClick={handleSend}
            />
          </Box>
        </Box>
      </DialogContent>
    </WideDialog>
  );
}
